<template>
  <div class="advertisementManageList">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>内容</el-breadcrumb-item>
      <el-breadcrumb-item>广告</el-breadcrumb-item>
      <el-breadcrumb-item>广告列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search-container">
      <el-form
        :inline="true"
        :model="customerGroupForm"
        class="demo-form-inline"
      >
        <el-form-item label="投放人群">
          <el-select
            v-model="customerGroupForm.search_group_uuid"
            placeholder="请选择"
          >
            <el-option
              v-for="(jtem, i) in userGroupList"
              :key="i"
              :label="jtem"
              :value="i"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期">
          <el-date-picker
            v-model="customerGroupForm.registerDate"
            type="daterange"
            align="right"
            unlink-panels
            @change="getTimes"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy/MM/dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="关键字" class="keyword">
          <el-input
            placeholder="请输入内容"
            v-model="customerGroupForm.search_keyword"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="btn mg-t-10">
        <el-button
          type="primary"
          size="medium"
          @click="getAdvertising(currentClass + 1)"
          >查询</el-button
        >
        <el-button size="medium" @click="clear">清空</el-button>
      </div>
    </div>
    <div class="dataTable">
      <div class="tabs flex">
        <p
          v-for="(item, index) in tabs"
          :key="index"
          @click="addClass(index)"
          :class="{ on: currentClass === index }"
        >
          {{ item }}
        </p>
      </div>
      <div class="text-right mg-b-20">
        <el-button type="primary" @click="$router.push('/addAdvertise')"
          >添加广告</el-button
        >
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData.data"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          label="序号"
          type="index"
          :align="'center'"
          width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="广告标题"
          :align="'center'"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="图片" prop="image" :align="'center'">
          <template slot-scope="scope">
            <div class="product">
              <el-image :src="scope.row.image"></el-image>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="group" label="投放人群" :align="'center'">
          <template slot-scope="scope">
            <span v-if="scope.row.group.length > 0"
              ><el-tag v-for="item in scope.row.group" :key="item.uuid">{{
                item.name
              }}</el-tag></span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="shelf_start_time"
          label="开始日期"
          :align="'center'"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="shelf_end_time"
          label="结束日期"
          :align="'center'"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="操作"
          :align="'center'"
          width="200"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 1"
              @click="upOrDown(scope.row)"
              type="text"
              size="small"
              >下架</el-button
            >
            <el-button
              v-else
              @click="upOrDown(scope.row)"
              type="text"
              size="small"
              >上架</el-button
            >
            <el-button type="text" @click="toEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="deleted(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="tableData.total"
        :per_page="tableData.per_page"
        :current_page="tableData.current_page"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>
<script>
import pagination from "../../../components/pagination.vue";
export default {
  name: "advertisementManageList",
  components: {
    pagination,
  },
  data() {
    return {
      registerDate: "",
      tabs: ["上架", "下架"],
      userGroupList: [],
      currentClass: 0,
      customerGroupForm: {
        search_keyword: "",
        search_group: "",
        search_start_time: "",
        search_end_time: "",
        search_group_uuid: [],
        search_status: 1,
      },

      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() -
                  start.getHours() * 60 * 60 * 1000 -
                  start.getMinutes() * 60 * 1000 -
                  start.getSeconds() * 1000 -
                  start.getMilliseconds()
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() -
                  3600 * 1000 * 24 * 1 -
                  start.getHours() * 60 * 60 * 1000 -
                  start.getMinutes() * 60 * 1000 -
                  start.getSeconds() * 1000 -
                  start.getMilliseconds()
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() -
                  3600 * 1000 * 24 * 7 -
                  start.getHours() * 60 * 60 * 1000 -
                  start.getMinutes() * 60 * 1000 -
                  start.getSeconds() * 1000 -
                  start.getMilliseconds()
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() -
                  3600 * 1000 * 24 * 30 -
                  start.getHours() * 60 * 60 * 1000 -
                  start.getMinutes() * 60 * 1000 -
                  start.getSeconds() * 1000 -
                  start.getMilliseconds()
              );
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      tableData: {
        data: [],
        per_page: 10,
        current_page: 1,
      },
    };
  },
  created() {
    this.getAdvertising(1);
    this.getUserGroup();
  },
  methods: {
    addClass(index) {
      this.currentClass = index;
      this.customerGroupForm.search_status = index + 1;
      this.getAdvertising();
    },
    clear() {
      for (let i in this.customerGroupForm) {
        this.customerGroupForm[i] = "";
      }
      this.getAdvertising();
    },
    // 选择时间
    getTimes(v) {
      this.customerGroupForm.search_start_time = v[0] + " 00:00:00";
      this.customerGroupForm.search_end_time = v[1] + " 23:59:59";
    },
    // 编辑跳转
    toEdit(row) {
      row.group = JSON.stringify(row.group);
      this.$router.push({
        name: "addAdvertise",
        query: { ...row },
      });
    },
    upOrDown(row) {
      this.axios({
        method: "put", //请求方法
        headers: {
          "Content-Type": "application/json;charset=utf-8",
          "X-Access-Token": this.storage.get("__token"),
          Authorization: `Bearer ${this.storage.get("__token")}`,
        },
        data: {
          status: row.status == 1 ? 2 : 1,
        },
        url: ` https://time.api.boyalife.cn/v1/cms/Advertising/status/${row.uuid}`,
      })
        .then(() => {
          this.$message.success("操作成功！");
          if (row.status == 1) {
            this.getAdvertising(1);
          } else {
            this.getAdvertising(2);
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.error.message);
        });
    },
    // 删除
    deleted(row) {
      this.$confirm("删除后无法恢复，确定删除吗？", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      }).then(() => {
        this.axios({
          method: "delete", //请求方法
          headers: {
            "Content-Type": "application/json;charset=utf-8",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/Advertising/${row.uuid}`,
        })
          .then(() => {
            this.$message.success("删除成功！");
            if (row.status == 1) {
              this.getAdvertising(1);
            } else {
              this.getAdvertising(2);
            }
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      });
    },

    getUserGroup() {
      this.axios({
        method: "get", //请求方法
        headers: {
          "Content-Type": "text/html;charset=UTF-8",
          "X-Access-Token": this.storage.get("__token"),
          Authorization: `Bearer ${this.storage.get("__token")}`,
        },
        url: ` https://time.api.boyalife.cn/v1/cms/UserGroupSelect`,
      })
        .then((res) => {
          this.userGroupList = res.data.result;
        })
        .catch((err) => {
          this.$message.error(err.response.data.error.message);
        });
    },
    // 列表
    getAdvertising(status) {
      this.axios({
        method: "get", //请求方法
        headers: {
          "Content-Type": "application/json",
          "X-Access-Token": this.storage.get("__token"),
          Authorization: `Bearer ${this.storage.get("__token")}`,
        },

        url: ` https://time.api.boyalife.cn/v1/cms/Advertising?search_group=${this.customerGroupForm.search_group}&page_size=${this.tableData.per_page}&page_index=${this.tableData.current_page}&search_keyword=${this.customerGroupForm.search_keyword}&search_start_time=${this.customerGroupForm.search_start_time}&search_end_time=${this.customerGroupForm.search_end_time}&search_group_uuid=${this.customerGroupForm.search_group_uuid}&search_status=${this.customerGroupForm.search_status}`,
      })
        .then((res) => {
          this.tableData = res.data.result;
        })
        .catch((err) => {
          this.$message.success(err);
        });
    },
    handleSizeChange(v) {
      this.tableData.per_page = v;
      this.getAdvertising(this.currentClass + 1);
    },
    handleCurrentChange(v) {
      this.tableData.current_page = v;
      this.getAdvertising(this.currentClass + 1);
    },
  },
};
</script>
<style scoped>
.customerGroupList {
  background: #f2f2f2;
}
.search-container {
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  font-size: 12px !important;
}
>>> .el-input-group {
  width: 400px;
}
.el-table .el-image {
  width: auto;
  height: auto;
}
.advertisementManageList .el-table .product .el-image {
  border-radius: 0 !important;
}
>>> .el-button--text {
  padding: 5px 0px;
}
>>> .el-button--text span {
  font-size: 12px;
}
>>> .el-dialog__body {
  padding: 20px;
}
>>> .el-table .el-button {
  width: 40px;
}
.dataTable {
  position: relative;
}
.dataTable .tabs {
  position: absolute;
  top: 35px;
  left: 20px;
}
.dataTable .tabs p {
  padding: 10px 20px;
  position: relative;
  cursor: pointer;
}
.dataTable .tabs p:after {
  content: "";
  width: 100%;
  height: 2px;
  background: none;
  position: absolute;
  left: 0;
  bottom: 0;
}
.dataTable .tabs p.on:after {
  background: #409eff;
}
.el-tag {
  margin-right: 5px;
  margin-bottom: 5px;
}
</style>
